import axios from 'axios';
import config from '../common/config';

export default {
  list( token, rideId ) {
    return axios.get(`${config.config.ROOT_URL}/api/rides/${rideId}/organizer_messages`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  create( token, rideId, payload ) {
    return axios.post(`${config.config.ROOT_URL}/api/rides/${rideId}/organizer_messages`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },
  update( token, messageId, payload ) {
    return axios.put(`${config.config.ROOT_URL}/api/organizer_messages/${messageId}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  },
  withdraw( token, messageId ) {
    return axios.delete(`${config.config.ROOT_URL}/api/organizer_messages/${messageId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
